// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper_WnLvb {
  grid-column: 1/-1;
  justify-self: stretch;
  width: 100%;
}

.grid_nxELF.win_q_m1A {
  width: 100%;
  padding : 0;
}

.editor_cNMzT {
  width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-rsrc-management/lib/components/detailRenderer/PlainTextDetail.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".wrapper {\n  grid-column: 1/-1;\n  justify-self: stretch;\n  width: 100%;\n}\n\n.grid.win {\n  width: 100%;\n  padding : 0;\n}\n\n.editor {\n  width: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper_WnLvb`,
	"grid": `grid_nxELF`,
	"win": `win_q_m1A`,
	"editor": `editor_cNMzT`
};
export default ___CSS_LOADER_EXPORT___;
